import { ObjectID } from 'bson';
import mongoose, { Schema } from 'mongoose';

export interface IExchangeRates {
  USD: number;
  EUR: number;
  JYP: number;
  GBP: number;
  PLS: number;
  HRK: number;
  HUF: number;
  IDR: number;
  PHP: number;
  TRY: number;
  RON: number;
  ISK: number;
  SEK: number;
  THB: number;
  PLN: number;
  CAD: number;
  AUD: number;
  MYR: number;
  NZD: number;
  CHF: number;
  DKK: number;
  SGD: number;
  CNY: number;
  BGN: number;
  CZK: number;
  BRL: number;
  JPY: number;
  KRW: number;
  INR: number;
  MXN: number;
  RUB: number;
  HKD: number;
  ZAR: number;
  ILS: number;
  NOK: number;
}

export interface IExchangeRatesDocument extends mongoose.Document, IExchangeRates {
  _id: ObjectID;
}

const exchangeRates = new Schema({
  USD: { type: Number, required: true },
  PLS: {
    type: Number,
    required: true,
  },
  HRK: { type: Number, required: true },
  HUF: { type: Number, required: true },
  IDR: { type: Number, required: true },
  PHP: { type: Number, required: true },
  TRY: { type: Number, required: true },
  RON: { type: Number, required: true },
  ISK: { type: Number, required: true },
  SEK: { type: Number, required: true },
  THB: { type: Number, required: true },
  PLN: { type: Number, required: true },
  GBP: { type: Number, required: true },
  CAD: { type: Number, required: true },
  AUD: { type: Number, required: true },
  MYR: { type: Number, required: true },
  NZD: { type: Number, required: true },
  CHF: { type: Number, required: true },
  DKK: { type: Number, required: true },
  SGD: { type: Number, required: true },
  CNY: { type: Number, required: true },
  BGN: { type: Number, required: true },
  CZK: { type: Number, required: true },
  BRL: { type: Number, required: true },
  JPY: { type: Number, required: true },
  KRW: { type: Number, required: true },
  INR: { type: Number, required: true },
  MXN: { type: Number, required: true },
  RUB: { type: Number, required: true },
  HKD: { type: Number, required: true },
  ZAR: { type: Number, required: true },
  ILS: { type: Number, required: true },
  NOK: { type: Number, required: true },
});

export default exchangeRates;
